import { createReducer, on } from '@ngrx/store';

import {
	getDetailsForConnectedUser,
	getDetailsForConnectedUserSuccess,
	getOrganizationSuccess,
	switchViewMode,
} from './app.actions';
import { CoreState } from './app.state';

export const coreReducer = createReducer<CoreState>(
	new CoreState(),
	on(getOrganizationSuccess, (state, action) =>
		state.setOrganization(action.organization),
	),
	on(switchViewMode, (state, action) =>
		state.setUserPreference(state.userPreference.setViewMode(action.viewMode)),
	),
	on(getDetailsForConnectedUser, (state, action) =>
		state.setConnectedUser(action.user),
	),
	on(getDetailsForConnectedUserSuccess, (state, action) =>
		state
			.setConnectedUser(
				state.connectedUser.setAvailableInstanceModules(action.instanceModules),
			)
			.setOrganization(action.organizationPerUserAccount)
			.setSelectedOrganization(action.defaultOrganizationId)
			.setUserPreference(action.userMarketplacePreferences),
	),
);
